import { createContext } from "react";

import { UseGlobalNavProductRecommendationsResponse } from "../hooks/use-global-nav-product-recommendations";

const noop = () => {
    // do nothing
};

export const NavProductRecommendationsContext =
    createContext<UseGlobalNavProductRecommendationsResponse>({
        onGlobalNavProductRecommendationsFailed: noop,
        shouldShowGlobalNavProductRecommendations: false,
        recommendations: [],
        isRecommendationLoading: false,
        mobileNavPageLabelFeaturedProducts: "",
        fireGlobalNavProductRecoEventsWhenInView: noop
    });
